import { IDrivers, IRequestPostDocument } from "store/lobby/lobby-api";
import { ISaleChannel } from "store/lobby/lobby-model";
import Request from "utils/requests/api";
import initializeConfig from "utils/requests/api.config";

export const BASE_URL_GATES_EVENTS = async () => {
  const { gates } = await initializeConfig();
  return `${gates}gate-events/`;
};

export const BASE_URL_TRUCKS = async () => {
  const { gates } = await initializeConfig();
  return `${gates}trucks`;
};

export const BASE_URL_YARD_REGISTERS = async () => {
  const { gates } = await initializeConfig();
  return `${gates}yard-registers`;
};

export const BASE_URL_SUMMARIES = async () => {
  const { gates } = await initializeConfig();
  return `${gates}summaries/`;
};

export const BASE_URL_DOCUMENTS = async () => {
  const { gates } = await initializeConfig();
  return `${gates}documents`;
};

export const BASE_URL_DOCUMENTS_MANAGER = async () => {
  const { documentsManager } = await initializeConfig();
  return `${documentsManager}`;
};

export interface IRequestAttendance {
  locationId: number;
  _size: number;
  _page: number;
  orderbySchedule: string;
  filter: string;
  processIds?: number[];
  saleChannelIds?: number[];
  vehicleStepStatus?: number;
}

export interface IRequestSummary {
  processIds?: number[];
  saleChannelIds?: number[];
  vehicleStepStatus?: number;
  locationId: number;
}

export interface IRequestPostCheckin {
  carrier: string;
  vehiclePlate: string;
  trailersPlates: string[];
  observation: string;
  eventTime: string;
  user?: string;
  locationId: number;
  processId: number;
  saleChannel: ISaleChannel;
  processDescription: string;
  documents: IRequestPostDocument[];
  fromCheckin?: boolean;
  drivers?: IDrivers[];
  trailerType?: number;
}

export interface IRequestPutCheckin {
  user?: string;
  eventTime: string;
  trailersPlates: string[];
  locationId: number;
  processId: number;
  processDescription: string;
  carrier: string;
  vehiclePlate: string;
  documents: IRequestPostDocument[];
  drivers?: IDrivers[];
  saleChannel: ISaleChannel;
  trailerType?: number;
}

export interface IRequestPutInbound {
  carrier: string;
  vehiclePlate: string;
  trailersPlates: string[];
  observation: string;
  eventTime: string;
  user?: string;
  processId: number;
  processDescription: string;
  documents: IRequestPostDocument[];
  drivers?: IDrivers[];
  saleChannel?: ISaleChannel;
  trailerType?: number;
}

export interface IRequestInboundUpdate {
  gateEventId: number;
}

export const getAttendance = async ({ _size, _page, orderbySchedule, locationId, filter, processIds, saleChannelIds, vehicleStepStatus }: IRequestAttendance) => {
  const baseUrlYardRegisters = await BASE_URL_YARD_REGISTERS();
  return (await Request).get(`${baseUrlYardRegisters}:paginated`, {
    locationId,
    _size,
    _page,
    orderbySchedule,
    filter,
    processIds,
    saleChannelIds,
    vehicleStepStatus,
  });
};

export const saveRequestVehicleForGate = async (id) => {
  const baseUrlGatesEvents = await BASE_URL_GATES_EVENTS();
  return (await Request).post(`${baseUrlGatesEvents}${id}:request-vehicle-for-gate`);
};

export const saveReleaseVehicle = async (id) => {
  const baseUrlGatesEvents = await BASE_URL_GATES_EVENTS();
  return (await Request).post(`${baseUrlGatesEvents}${id}:request-vehicle-entry-authorization`);
};

export const saveRequestVehicleForDock = async ({ id, dock }) => {
  const baseUrlGatesEvents = await BASE_URL_GATES_EVENTS();
  return (await Request).post(`${baseUrlGatesEvents}${id}:request-dock-entry`, { dock });
};

export const saveCheckinRegister = async (params: IRequestPostCheckin) => {
  const baseUrlTrucks = await BASE_URL_TRUCKS();
  return (await Request).post(`${baseUrlTrucks}:checkin`, params);
};

export const deleteCheckinRegister = async (yardRegisterId) => {
  const baseUrlTrucks = await BASE_URL_TRUCKS();
  return (await Request).delete(`${baseUrlTrucks}:checkin/${yardRegisterId}`);
};

export const updateChekin = async (params: IRequestPutCheckin) => {
  const baseUrlTrucks = await BASE_URL_TRUCKS();
  return (await Request).put(`${baseUrlTrucks}:checkin`, params);
};

export const getEventsHistory = async (yardRegisterId: number) => {
  const baseUrlYardRegisters = await BASE_URL_YARD_REGISTERS();
  return (await Request).get(`${baseUrlYardRegisters}/${yardRegisterId}/event-history`);
};

export const getVehicleStatus = async () => {
  const baseUrlYardRegisters = await BASE_URL_YARD_REGISTERS();
  return (await Request).get(`${baseUrlYardRegisters}/vehicle-steps-status`);
};

export const getSummary = async ({ locationId, processIds, saleChannelIds, vehicleStepStatus }: IRequestSummary) => {
  const baseUrlSummaries = await BASE_URL_SUMMARIES();
  return (await Request).get(`${baseUrlSummaries}`, { locationId, processIds, saleChannelIds, vehicleStepStatus });
};

export const updateInbound = async (params: IRequestPutInbound, gateEventId: IRequestInboundUpdate) => {
  const baseUrlTrucks = await BASE_URL_TRUCKS();
  return (await Request).put(`${baseUrlTrucks}:inbound/${gateEventId}`, params);
};

export const getItemsCheckin = async (yardRegisterId) => {
  const baseUrlGatesDocuments = await BASE_URL_DOCUMENTS();
  return (await Request).get(`${baseUrlGatesDocuments}:load-items?yardRegisterId=${yardRegisterId}`);
};
